import { useToastsStore } from "@/store/toasts";
import { useRouter } from "vue-router";

export const useTimedReload = () => {
    const toastsStore = useToastsStore();
    const router = useRouter();
    
    const reload = () => {

        toastsStore.toast({
            title: 'Riavvio',
            text: 'L\'applicazione sta per essere riavviata per effettuare il cambio giornata attiva',
            type: 'warning',
            duration: 10000,
            showUICountdown: true,
            callbackOnHide: ()=> { 
                router.push({ name: 'root' }).then(() => {
                    // Once navigation is complete, reload the whole application
                    window.location.reload();
                });
                window.location.reload()
            }
        })
    }

    const activate = () => {

        //helper function to build up the desire time trigger
        const forcePageReloadGetTargetTime = (dayDelta, hourDayTime, minuteDayTime) => {
            const t = new Date();
            t.setDate(t.getDate() + dayDelta);
            t.setHours(hourDayTime);
            t.setMinutes(minuteDayTime);
            t.setSeconds(0);
            t.setMilliseconds(0);
            return t;
        }



        // dayDelta: 1 = tomorrow, 0 = today, -1 = yesterday
        // hourDayTime: 0-23
        // minuteDayTime: 0-59

        // tomorrow, at 00:02


        const timetarget = forcePageReloadGetTargetTime(1, 0, 2).getTime();
        const timenow = new Date().getTime();
        const offsetmilliseconds = timetarget - timenow;

        //if it isn't midnight yet, set a timeout.
        if (offsetmilliseconds >= 0) {
            setTimeout( reload , offsetmilliseconds);
        }

        // offsetmilliseconds in hh mm ss 
        const offset = new Date(offsetmilliseconds);
        const hours = offset.getUTCHours();
        const minutes = offset.getUTCMinutes();
        const seconds = offset.getUTCSeconds();

        console.log(`⏳ Timed reload activated, reload in ${hours}h ${minutes}m ${seconds}s`);
    };

    return {
        activate,
        reload
    };
};




